import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import useWindowDimensions from '../../hooks/useWindowDimensions';
import IndotechMap from './IndotechMap';
import InformationField from './InformationField';
import LocationList from './LocationList';

function Information({ locations, webPage }) {
    const [t] = useTranslation('ourDistributors');
    const { isMobile } = useWindowDimensions();

    const hasMultipleLocations = locations.length > 1;

    const mobileStyle = 'flex flex-col p-8';
    const browserStyle = 'flex min-h-[650px] flex-1 flex-col justify-center pl-16';

    const onClickWebsite = () => {
        window.open(`https://${webPage}`, '_blank');
    };

    const onClickAddress = (address) => {
        window.open(`https://google.ca/maps/search/${address}`, '_blank');
    };

    return (
        <div className={`flex w-full max-w-screen-xl flex-1 flex-col-reverse pb-10 sm:flex-row`}>
            <div className={`${isMobile ? mobileStyle : browserStyle}`}>
                {hasMultipleLocations ? (
                    <LocationList
                        locations={locations}
                        onClickAddress={onClickAddress}
                    />
                ) : (
                    <>
                        <InformationField
                            label={t('address')}
                            value={locations[0]?.address}
                            valueStyle={'hover:cursor-pointer hover:text-opacity-50'}
                            onValueClick={() => onClickAddress(locations[0]?.address)}
                        />

                        <InformationField
                            label={t('contact')}
                            value={locations[0]?.contact}
                            className={'mt-12 sm:mt-20'}
                        />
                    </>
                )}

                <InformationField
                    label={t('web_page')}
                    value={webPage}
                    valueStyle={'hover:cursor-pointer hover:text-opacity-50'}
                    onValueClick={onClickWebsite}
                    className={'mt-12 sm:mt-20'}
                />
            </div>

            <IndotechMap locations={locations} />
        </div>
    );
}

Information.propTypes = {
    locations: PropTypes.array,
    webPage: PropTypes.string,
};

Information.defaultProps = {
    locations: [],
    webPage: '',
};

export default Information;
